import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataApiService } from '../Services/data-api.service';

@Injectable({
  providedIn: 'root'
})
export class JarwisService {
  

  private baseUrl = this.dataApi.url;

  constructor(
    private http : HttpClient,
    private dataApi : DataApiService

  ) { }
  //signup persona
  signup(data){
    return this.http.post(`${this.baseUrl}/signup`,data)
  }
  
  //signup empresa
  signupEmpresa(data){
    return this.http.post(`${this.baseUrl}/signupEmpresa`,data)
  }

  login(data){
    return this.http.post(`${this.baseUrl}/login`,data)
  } 

  nuevoPedido(data){
    return this.http.post(`${this.baseUrl}/nuevoPedido`,data)
  }

  cuentaSecundaria(data){
    return this.http.post(`${this.baseUrl}/cuentaSecundaria`,data)
  } 
  actualizarContrasena(data){
    return this.http.post(`${this.baseUrl}/actualizarContrasena`,data)
  }
}
